<template>
<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg5418"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs5422"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath5432"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path5430" /></clipPath></defs><g
     id="g5424"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g5426"><g
         id="g5428"
         clip-path="url(#clipPath5432)"><g
           id="g5434"
           transform="translate(158.2969,234.4326)"><path
             d="m 0,0 h 339.223 c 3.336,0 6.041,-2.705 6.041,-6.041 v -36.372 c 0,-3.336 -2.705,-6.04 -6.041,-6.04 h -48.81"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path5436" /></g><g
           id="g5438"
           transform="translate(413.71,185.9795)"><path
             d="m 0,0 h -399.229 c -3.337,0 -6.041,2.704 -6.041,6.04 v 36.372 c 0,3.336 2.704,6.041 6.041,6.041 h 108.816"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path5440" /></g><g
           id="g5442"
           transform="translate(18.6992,185.9795)"><path
             d="m 0,0 v -171.54 c 0,-3.832 3.107,-6.939 6.94,-6.939 h 460.721 c 3.833,0 6.941,3.107 6.941,6.939 V 0"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path5444" /></g><g
           id="g5446"
           transform="translate(225.1958,427.6621)"><path
             d="m 0,0 c 3.45,-3.052 8.912,-0.776 9.25,3.818 l 0.495,6.714 c 2.624,35.631 -24.445,65.864 -60.17,66.301 -35.907,0.439 -64.387,-29.937 -61.758,-65.64 0.945,-12.821 11.469,-22.836 24.321,-23.123 1.765,-0.039 3.626,-0.005 5.59,0.114 26.376,1.585 48.14,25.11 58.981,47.368 C -17.203,18.827 -8.593,7.602 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path5448" /></g><g
           id="g5450"
           transform="translate(119.4541,423.8838)"><path
             d="m 0,0 2.442,-33.158 c 2.01,-27.292 35.656,-46.205 52.105,-46.205 16.449,0 50.096,18.913 52.106,46.205 l 2.618,35.551"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path5452" /></g><g
           id="g5454"
           transform="translate(98.7236,273.5654)"><path
             d="M 0,0 V -39.133"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path5456" /></g><g
           id="g5458"
           transform="translate(249.2793,273.5654)"><path
             d="M 0,0 V -39.133"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path5460" /></g><g
           id="g5462"
           transform="translate(354.3506,335.0215)"><path
             d="m 0,0 h -54.185 c -2.066,0 -3.742,1.676 -3.742,3.742 v 21.797 c 0,2.066 1.676,3.742 3.742,3.742 H 0 c 2.066,0 3.741,-1.676 3.741,-3.742 V 3.742 C 3.741,1.676 2.066,0 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path5464" /></g><path
           d="m 339.878,304.948 h -25.239 v 30.073 h 25.239 z"
           style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
           id="path5466" /><g
           id="g5468"
           transform="translate(397.1348,324.3584)"><path
             d="m 0,0 v 19.11 c 0,6.904 5.596,12.5 12.5,12.5"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path5470" /></g><g
           id="g5472"
           transform="translate(450.0977,300.2051)"><path
             d="m 0,0 h -24.315 c -2.015,0 -3.648,1.633 -3.648,3.647 v 39.617 c 0,6.903 -5.597,12.5 -12.5,12.5 h 31.61 c 6.904,0 12.5,-5.597 12.5,-12.5 V 3.647 C 3.647,1.633 2.015,0 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path5474" /></g><g
           id="g5476"
           transform="translate(448.71,234.4326)"><path
             d="M 0,0 V 65.772"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path5478" /></g><g
           id="g5480"
           transform="translate(422.1348,324.3584)"><path
             d="m 0,0 h -37.909 c -3.331,0 -6.031,-2.7 -6.031,-6.031 v -5.034 c 0,-4.609 -3.737,-8.346 -8.346,-8.346 h -89.536 c -3.332,0 -6.033,-2.7 -6.033,-6.032 v -64.483"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path5482" /></g><g
           id="g5484"
           transform="translate(299.2793,259.4326)"><path
             d="M 0,0 H 124.431"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path5486" /></g><g
           id="g5488"
           transform="translate(288.9062,304.9473)"><path
             d="M 0,0 C -3.413,14.966 -16.804,26.134 -32.803,26.134 H -71.081 C -74.726,21.926 -80.645,15.15 -86.97,7.927 c -14.791,-16.892 -41.079,-16.892 -55.869,0 -6.326,7.223 -12.245,13.999 -15.89,18.207 h -38.278 c -18.581,0 -33.644,-15.064 -33.644,-33.645 v -63.004"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path5490" /></g><g
           id="g5492"
           transform="translate(292.9502,41.4551)"><path
             d="m 0,0 h 17.603 c 3.293,0 6.039,2.525 6.313,5.808 l 6.17,73.801 h -134.072 l 6.17,-73.801 C -97.542,2.525 -94.797,0 -91.503,0 H -35"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path5494" /></g><g
           id="g5496"
           transform="translate(218.6172,66.4551)"><path
             d="M 0,0 -2.476,29.609"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path5498" /></g><g
           id="g5500"
           transform="translate(243.5391,66.4551)"><path
             d="M 0,0 -0.825,29.609"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path5502" /></g><g
           id="g5504"
           transform="translate(268.4609,66.4551)"><path
             d="M 0,0 0.825,29.609"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path5506" /></g><g
           id="g5508"
           transform="translate(293.3828,66.4551)"><path
             d="M 0,0 2.476,29.609"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path5510" /></g><g
           id="g5512"
           transform="translate(282.9502,121.0645)"><path
             d="M 0,0 -8.296,30.959"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path5514" /></g><g
           id="g5516"
           transform="translate(237.3457,152.0234)"><path
             d="M 0,0 -8.295,-30.959"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path5518" /></g><g
           id="g5520"
           transform="translate(180.8613,121.0645)"><path
             d="M 0,0 H 150.277"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path5522" /></g><g
           id="g5524"
           transform="translate(234.9868,331.0811)"><path
             d="M 0,0 V 107.773"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path5526" /></g><g
           id="g5528"
           transform="translate(113.0132,438.8545)"><path
             d="M 0,0 V -107.773"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path5530" /></g><g
           id="g5532"
           transform="translate(97.0269,331.0811)"><path
             d="m 0,0 14.254,-16.368 c 0,0 9.617,-11.043 15.977,-18.308 9.004,-10.283 21.061,-17.219 34.228,-19.927 v -14.093 c 0,-1.631 1.321,-2.952 2.952,-2.952 h 19.303 c 1.631,0 2.953,1.321 2.953,2.952 v 14.13 c 13.098,2.733 25.087,9.653 34.052,19.891 6.36,7.264 15.976,18.307 15.976,18.307 L 153.948,0"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path5534" /></g><g
           id="g5536"
           transform="translate(217.8257,331.0811)"><path
             d="m 0,0 h -10.456 c -2.659,0 -4.814,2.155 -4.814,4.814 v 19.394"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path5538" /></g><g
           id="g5540"
           transform="translate(145.4473,355.2891)"><path
             d="m 0,0 v -19.394 c 0,-2.659 -2.156,-4.814 -4.815,-4.814 H -15.27"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path5542" /></g></g></g></g></svg>
</template>
